import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Resource, ResourcesListingFilter } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  resources: Identifiable<Resource>[];
  filter: ResourcesListingFilter;
  totalPages: number;
  retrievePlanzoneResourcesListing(
    request: Boundaries["retrievePlanzoneResourcesListing"]["request"],
  ): void;
}

function useRetrievePlanzoneResourcesListing(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrievePlanzoneResourcesListingRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrievePlanzoneResourcesListingRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrievePlanzoneResourcesListingRequestFailure,
    ),
    resources: useSelector(selector.getPlanzoneResourcesListing),
    filter: useSelector(selector.getPlanzoneResourcesListingFilter),
    totalPages: useSelector(selector.getPlanzoneResourcesListingTotalPages),
    retrievePlanzoneResourcesListing: core.retrievePlanzoneResourcesListing,
  };
}

export { useRetrievePlanzoneResourcesListing };
